import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AbTests, AbTestUrls, TestId, VariantId } from '../abtests';
import { AnalyticsService } from './analytics.service';
import { Router, Event, RouterEvent } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AbTestService {
    constructor(
        private analyticsService: AnalyticsService,
        private cookieService: CookieService,
        private router: Router
    ) { }

    initialize() {
        this.router.events.pipe(filter((e: Event): e is RouterEvent => e instanceof RouterEvent)).subscribe((e: RouterEvent) => {
            this.assignTests(e.url);
        })
    }

    getCookieName(testName: TestId): string {
        return `abtest_${testName}`;
    }

    getVariantForTest<T extends TestId>(testName: T): typeof AbTests[T][number]|null {
        const cookieValue = this.cookieService.get(this.getCookieName(testName)) as VariantId;
        return cookieValue ?? null;
    }

    assignTests(url: string): void {
        const pageTests = Object.keys(AbTestUrls).filter(x => AbTestUrls[x] === url);
        pageTests.forEach((test: TestId) => {
            const currentVariant = this.getVariantForTest(test);
            if (currentVariant) return;

            const variantsForTest = AbTests[test];

            const variant = Math.floor(Math.random() * variantsForTest.length);
            const value = variantsForTest[variant];
            this.cookieService.set(this.getCookieName(test), value);

            this.analyticsService.sendEvent('AbTest', 'abtest', value);
        })
    }
}
